/**
 * The prototype's `tool(icon, label, action)`: a square icon button with a tooltip (`data-tip`), an
 * accessible name and a native title. Used in the top bar, panes, rows and dialogs.
 */

import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { Icon } from '../icons/Icon.js';

export interface ToolProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: string;
  label: string;
  /** aria-pressed for toggles; omit for plain buttons. */
  pressed?: boolean;
  /** Draws the label as a tooltip (default true). */
  tip?: boolean;
}

export const Tool = forwardRef<HTMLButtonElement, ToolProps>(function Tool({ icon, label, pressed, tip = true, className, type = 'button', ...rest }, ref) {
  return (
    <button
      ref={ref}
      type={type}
      className={className ? `tool ${className}` : 'tool'}
      aria-label={label}
      title={label}
      data-tip={tip ? label : undefined}
      aria-pressed={pressed === undefined ? undefined : pressed}
      {...rest}
    >
      <Icon name={icon} />
    </button>
  );
});
